<template>
  <div class="nkn-cdn">
<!--    <div class="common-title">{{$t("home.platformServices.platformServicesTitle")}}</div>-->
    <div class="nkn-container">
      <div class="header-text">
        <div class="header-text-title">
          <router-link tag="a" :to="langTo('/ncdn/')" target="_blank">{{$t("home.platformServices.nCDN.title")}}</router-link>
        </div>
        <div class="header-text-content">
          <div v-html="$t('home.platformServices.nCDN.desc')"></div>
        </div>
      </div>
      <div class="header-img">
        <router-link tag="a" :to="langTo('/ncdn/')" target="_blank">
          <img v-lazy="'/static/img/ncdn/ncdn-banner-1.png'" style="max-width:100%;width:400px;height: auto;">
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'

  export default {
    components: {
    },
    data: function () {
      return {
        notice: true,
        screenWidth: document.body.clientWidth,
        swiperOption: {
          slidesPerView: 1,
          loop: false,
          // 自动播放
          autoplay: {
            delay: 15000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        lang: 'getLang'
      })
    },
    mounted() {
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          this.screenWidth = window.screenWidth
        })()
      }
    },
    methods: {
      langTo(path){
        let root = ''
        if (!!this.$route.params.lang) {
          root = `/${this.$route.params.lang}`
        }
        return `${root}${path}`
      },
      noticeClick: function () {
        this.notice = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    .nkn-cdn .home-header-notice {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 !important;
      height: 6.5rem !important;
    }
    .nkn-cdn .container {
      height: auto !important;
    }

  }

  .nkn-container{
    @media screen and (max-width: 768px) {
      flex-direction: column-reverse;
      padding-left: 0;padding-right: 0; padding-top: 0; align-items: center;
    }
    max-width: 1200px;justify-content: space-between;align-items: center;
    width:100%;left:0;right:0;margin-left: auto;margin-right: auto;
    padding-left: 75px;padding-right: 75px; padding-top: 20px;
    display: flex;z-index: 100;
  }
  .header-background {
    display: block;
    position: absolute;
    bottom: 0;
    justify-self: center;
    align-self: center;
    width: 1200px;
    max-width: 2000px;
    margin-left: auto;
    margin-right: auto;
  }

  .header-background-media {
    display: none;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    justify-self: flex-end;
    align-self: center;
    width: 100%;
    min-width: 100%;
    bottom: 0;
  }

  @media screen and (max-width: 768px) {
    .header-background {
      display: none;
    }
    .header-background-media {
      display: flex;
    }
    .header-img{
      max-width: 100%; width:400px; margin-bottom: 40px; margin-top: 30px;
      .news{
        left: 20px;
      }
      img{display: flex;align-self: center; margin: 0 auto;
        width: 274px;height:182px; padding-left: 20px; padding-right: 20px;}
    }
  }

  .swiper-besides-image-container {
    text-align: center;
    height: 100% !important;
    background: #08074f !important;

    .narwhal-released-spacer {

    }

    img {
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      /*height: 100%;*/
    }

  }

  .header-img{
    &:hover{
      @include nkn-font-set(14px, #ffffff, 500);
    }
    position: relative;
    .news{
      position: absolute;top: 0;
      background-image: url(~@/assets/img/home/news-bg@2x.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: left center;
      width: 270px;height: 58px;
      @include nkn-font-set(14px, #ffffff, 500);
      display: flex;
      padding-left: 30px;
      padding-top: 16px;
      .icon{
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url(~@/assets/img/home/news-icon@2x.png);
        height: 20px;width:20px; margin-right: 10px;
      }
    }
  }
  .nkn-cdn {
    position: relative;
    /*padding-top: 40px;*/
    padding-bottom: 80px;
    display: flex;
    flex-direction: column;


    @media screen and (max-width: 768px) {
      padding-top: 0; padding-bottom: 50px;
      .header-pic {
        margin-top: 20px;

        img {
          width: 345px;
          height: auto;
        }
      }
    }

    .header-text {
      width: 46%;
      max-width: 500px;
      min-width: 420px;
      color: #fff;
      white-space: pre-line;
      @media screen and (max-width: 768px) {
        max-width: 100%;
        position: relative;
        width: auto;
        min-width: auto;
        top: auto;
        right: auto;
        margin: 0 20px;
      }

      &-title {
        @include nkn-font-set(20px, #0096FF, 500);
        line-height: 50px;

        @media screen and (max-width: 768px) {
          font-size: 14px;
          width: auto;
          line-height: 20px;
        }
      }
      &-subtitle{
        font-size: 12px;
        color: #0096FF;
        font-weight: 500;
      }

      &-content {
        @include nkn-font-set(14px, #24397D);
        text-align: justify;
        line-height: 1rem;
        margin-top: .75rem;
        @media screen and (max-width: 768px) {
          font-size: 12px;
          width: auto;
          line-height: 16px;
        }
      }

      &-btn {
        margin-top: 1.25rem;

        .header-btn {
          width: 8rem;
          height: 2.8rem;
          border-radius: 2rem;
          box-sizing: border-box;
          @include nkn-font-set(.7rem, currentColor);
          text-align: center;

          &:hover {
            box-shadow: 0 0 .4rem .1rem #1A8FFF;
          }

          &-testnet {
            float: left;
            color: #1A8FFF;
            border: .1rem solid #1791f2;
            line-height: 2.6rem;
            @include nkn-font-set(16px, #1A8FFF, 600);
            @media screen and (max-width: 768px) {
              font-size: 12px;
            }
            &:hover {
              background: #1791f2;
            }
          }

          &-intro {
            float: right;
            background: #1791f2;
            color: #fff;
            line-height: 2.8rem;
            @include nkn-font-set(16px, #fff, 600);
            @media screen and (max-width: 768px) {
              font-size: 12px;
            }
            &:hover {
              background: #0570EE;
            }
          }
        }
      }

    }

    .header-pic {
      margin-top: 4rem;
    }

    .home-header-notice {
      width: 100%;
      background: #3752C2;
      position: fixed;
      bottom: 0;
      z-index: 10000;
      height: 4.5rem;
      padding: .75rem 2.5rem;

      .notice-cell {
        a {
          text-decoration: underline;
        }

        @media screen and (max-width: 768px) {
          padding: 0 6px !important;
        }
      }

      .header-notice {
        border-radius: 2rem;
        text-align: center;
        height: 2.5rem;
        line-height: 1.5rem;

        &-text {
          height: auto;
          background: #B23030;
          @include nkn-font-set(.9rem, #fff);

          @media screen and (max-width: 768px) {
            line-height: 16px;
            font-size: 12px;
            padding: 10px;
            transform: scale(.9);
          }
        }

        &-btn {
          height: auto;
          padding: .75rem 2rem;
          background: #253A7E;
          cursor: pointer;
          @include nkn-font-set(1.2rem, #fff);
          transition: all 0.2s;

          @media screen and (max-width: 768px) {
            height: 36px;
            line-height: 36px;
            font-size: 12px;
            padding: 0;
          }

          &:hover {
            background: #364A8E;
          }

          &:active {
            background: #364A8E;
          }
        }
      }
    }

    .slide-fade-leave-active {
      transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-leave-to {
      transform: translateX(10px);
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/nknCDN.vue